export const REPORTING_PERSON_SECTION_NAME = 'Reporting Officer';
export const LOCATION_SECTION_NAME = 'Incident Location';
export const DETAILS_SECTION_NAME = 'Incident Details';
export const INVOLVED_VEHICLES_SECTION_NAME = 'Involved Vehicles';
export const INVOLVED_PEOPLE_SECTION_NAME = 'People Involved';
export const ATTACHMENT_SECTION_NAME = 'Photos of the incident';
